import React, {Component} from 'react';
import {
    Button,
    Card,
    ConfigProvider,
    Form,
    Input,
    InputNumber,
    Modal,
    notification, Popconfirm,
    Space,
    Table,
    Tag,
    Tooltip
} from 'antd';
import './ApartmentList.css';
import {fetchRequest} from "../../../util/APIUtils";
import ServerError from "../../../common/ServerError";
import Highlighter from 'react-highlight-words';
import {
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    FilePdfOutlined,
    PlusOutlined,
    SearchOutlined
} from '@ant-design/icons';
import NotFound from "../../../common/NotFound";
import AccessError from "../../../common/AccessError";
import moment from "moment";
import {language} from "../../../util/language";



class ApartmentList extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            content: [],
            total: 0,
            current: 1,
            pageSize: 5,
            pageSizeOptions: ['5', '10', '20', '50', '100'],
            loading: false,
            searchQuery: '',
            keySearchQuery: '',
            accessor: 'recordId',
            direction: 'desc',
            openExportExcelModal: false,
            addModalVisible: false,
            formData: {
                name: '',
                buildingNo: '',
                buildingName: '',
                apartmentNo: '',
                streetName: '',
                postalCode: '',
                city: '',
                currencyType: '',
                amount: null,},
            mode: null,
            serverError: false,
            notFound: false,
            accessError: false,
        };
        this.fetchData = this.fetchData.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.deleteApartmentRecord = this.deleteApartmentRecord.bind(this);
        this.setSearchQuery = this.setSearchQuery.bind(this);
        this.setModalVisible = this.setModalVisible.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.editApartmentRecord = this.editApartmentRecord.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let self = this;
        this.setState({loading: true});
        const {accessor, direction, current, pageSize, searchQuery, keySearchQuery} = self.state;
        fetchRequest({}, `/apartment/fetch?page=${current - 1}&size=${pageSize}${keySearchQuery + searchQuery}&sort=${accessor},${direction}`)
            .then(response => {
                console.log("resp", response.data)
                let {number, size, totalElements, content} = response.data;
                this.setState({
                    loading: false,
                    current: number + 1,
                    pageSize: size,
                    total: totalElements,
                    content
                });
            }).catch(error => {
            if (error.status === 404) {
                this.setState({notFound: true});
            } else if (error.response.status === 401) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: language(this.props.lang, 'user_name_or_password_is_wrong')
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: language(this.props.lang, 'error'),
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if (error.response.status === 403) {
                notification.error({
                    message:  language(this.props.lang, 'error'),
                    description:  language(this.props.lang, 'error_permission')
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
            this.setState({loading: false});
        });
    }

    handleAdd(formData) {
        console.log(formData)
        this.setState({loading: true});
        fetchRequest(formData, '/apartment/save').then(response => {
            if (response.status === 200) {
                notification.success({
                    message: language(this.props.lang, 'success'),
                });
                this.fetchData();
                this.setState({formData: {}, addModalVisible: false});
            }else{
                notification.error({
                    message: 'Hata',
                    description: response.data
                });
                this.setState({accessError: true});
            }
        }).catch(error => {
            if (error.status === 404) {
                this.setState({notFound: true});
            } else if (error.response.status === 401) {
                notification.error({
                    message: 'Hata',
                    description: 'Kullanıcı adı veya şifre hatalı, tekrar deneyiniz!'
                });
            } else if (error.response.status === 400) {
                notification.error({
                    message: 'Hata',
                    description: error.response.data
                });
                this.setState({notFound: true});
            } else if (error.response.status === 403) {
                notification.error({
                    message: 'Hata',
                    description: "Bu sayfayı görmeye yetkiniz bulunmamaktadır."
                });
                this.setState({accessError: true});
            } else {
                this.setState({serverError: true});
            }
        })
        this.setState({loading: false, });
        console.log(this.state.formData);
    }

    onChange(pagination, filters, sorter, extra) {
        let searchQuery = '';
        if (filters.name && filters.name.length > 0) {
            searchQuery = searchQuery + `&name=${filters.name[0]}`;
        }
        if (filters.buildingNo && filters.buildingNo.length > 0) {
            searchQuery = searchQuery + `&buildingNo=${filters.buildingNo[0]}`;
        }
        if (filters.buildingName && filters.buildingName.length > 0) {
            searchQuery = searchQuery + `&buildingName=${filters.buildingName[0]}`;
        }
        if (filters.apartmentNo && filters.apartmentNo.length > 0) {
            searchQuery = searchQuery + `&apartmentNo=${filters.apartmentNo[0]}`;
        }
        if (filters.streetName && filters.streetName.length > 0) {
            searchQuery = searchQuery + `&streetName=${filters.streetName[0]}`;
        }
        if (filters.postalCode && filters.postalCode.length > 0) {
            searchQuery = searchQuery + `&postalCode=${filters.postalCode[0]}`;
        }
        if (filters.city && filters.city.length > 0) {
            searchQuery = searchQuery + `&city=${filters.city[0]}`;
        }

        this.setState({
            searchQuery,
            accessor: sorter.field ? sorter.field : this.state.accessor,
            direction: sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : this.state.direction,
            current: pagination.current,
            pageSize: pagination.pageSize
        }, () => this.fetchData());
    }

    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    }

    handleReset(clearFilters) {
        clearFilters();
        this.setState({searchText: ''});
    }

    handleMenuClick(e) {
        let item = e.item;
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div style={{padding: 8}}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={language(this.props.lang, 'search')}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{width: 188, marginBottom: 8, display: 'block'}}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined/>}
                    size="small"
                    style={{width: 90, marginRight: 8}}
                >
                    {language(this.props.lang, 'search')}
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
                    {language(this.props.lang, 'clear')}
                </Button>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined, }}/>,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });



    deleteApartmentRecord(recordID) {
        let self = this;
        const url = `/apartment/remove/${recordID}`;
        self.setState({loading: true})
        fetchRequest({}, url).then(response => {
            self.setState({loading: false})
            notification.success({
                message: language(self.props.lang, 'success'),
                description: language(self.props.lang, 'delete_success')
            });
        }).catch(error => {
            self.setState({loading: false})
            notification.error({
                message: language(self.props.lang, 'error'),
                description: language(self.props.lang, 'delete_denied')
            });
        })
    }

    /*editApartmentRecord(recordID) {
        let self = this;
        const url = `/apartment/edit/${recordID}`;
        self.setState({loading: true})
        fetchRequest({}, url).then(response => {
            self.setState({loading: false})
            self.setModalVisible(true);
            self.setState({formData: response.data});
        }).catch(error => {
            self.setState({loading: false})
        })
    }*/

    editApartmentRecord(record){
        let self = this;
        const mapped = self.normalizeRecord(record)
        self.setState({addModalVisible: true, mode: 'edit', formData:mapped}, () => {
            console.log(self.state.formData);
        });
    }

    normalizeRecord(record) {
        let self = this;
        let {buildingNo, name, buildingName, apartmentNo, streetName, postalCode, city, currencyType, amount} = record;
        return {
            buildingNo,
            name,
            buildingName,
            apartmentNo,
            streetName,
            postalCode,
            city,
            currencyType,
            amount
        }
    }

    setModalVisible(visible) {
        this.setState({addModalVisible: visible});
    }

    setSearchQuery(text) {
        let self = this;
        self.setState({keySearchQuery: text, total: 0, current: 1, pageSize: 5}, () => self.fetchData());
    }


    handleChange(e) {
        const {name, value} = e.target;
        this.setState((prev) => ({formData: {...prev.formData, [name]: value}}));
    }

    render() {
        if (this.state.serverError) {
            return <ServerError/>;
        }

        if (this.state.notFound) {
            return <NotFound/>;
        }

        if (this.state.accessError) {
            return <AccessError/>;
        }

        const columns = [
            {
                title: '#',
                dataIndex: 'index',
                key: 'index',
                width: '3%',
                render: (text, record, index) => (
                    <label>{index + 1}</label>
                )
            },
            {
                title: language(this.props.lang, 'building_no'),
                dataIndex: 'buildingNo',
                key: 'buildingNo',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('buildingNo'),
            },
            {
                title: language(this.props.lang, 'site_name'),
                dataIndex: 'name',
                key: 'name',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('name'),
            },
            {
                title: language(this.props.lang, 'building_name'),
                dataIndex: 'buildingName',
                key: 'buildingName',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('buildingName'),
            },
            {
                title: language(this.props.lang, 'apartment_no'),
                dataIndex: 'apartmentNo',
                key: 'apartmentNo',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('apartmentNo'),
            },
            {
                title: language(this.props.lang, 'street_name'),
                dataIndex: 'streetName',
                key: 'streetName',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('streetName'),
            }, {
                title: language(this.props.lang, 'postal_code'),
                dataIndex: 'postalCode',
                key: 'postalCode',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('postalCode'),
            }, {
                title: language(this.props.lang, 'city'),
                dataIndex: 'city',
                key: 'city',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('city'),
            }, {
                title: language(this.props.lang, 'currency_type'),
                dataIndex: 'currencyType',
                key: 'currencyType',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                ...this.getColumnSearchProps('currencyType'),
            },
            {
                title: language(this.props.lang, 'amount'),
                dataIndex: 'amount',
                key: 'amount',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
            },
            {
                title: language(this.props.lang, 'apartment_status'),
                dataIndex: 'status',
                key: 'status',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                render: status => {
                    const color = status === "EMPTY" ? 'green' : 'volcano';
                    const text = status === "EMPTY" ? language(this.props.lang, 'empty') : language(this.props.lang, 'reserved');
                    return (<Tag color={color}>{text}</Tag>)
                }
            },
            {
                title: language(this.props.lang, 'updated_at'),
                dataIndex: 'updatedAt',
                key: 'updatedAt',
                width: '15%',
                sorter: true,
                onHeaderCell: () => ({className: this.props.lang === 'ar' ? 'rtl-th' : 'ltr-th'}),
                render: (text, record) => (
                    <label>{moment(record.updatedAt).format("DD-MM-YYYY HH:mm")}</label>
                )
            },
            {
                title: language(this.props.lang, 'actions'),
                key: 'actions',
                width: '10%',
                render: (text, record) => (
                    <Space>
                        <Popconfirm title={language(this.props.lang, "sure_to_delete")}  onConfirm={() =>this.deleteApartmentRecord(record.recordId)}>
                            <Button icon={<DeleteOutlined/>} shape="circle" type="danger"/>
                        </Popconfirm>
                        <Button icon={<EditOutlined/>} shape="circle" type="ghost" onClick={() => this.setState({addModalVisible: true, mode: 'edit', formData: record})}/>
                    </Space>
                )
            },
        ];

        const {total, current, pageSize, pageSizeOptions, content} = this.state;
        let {formData} = this.state;
        console.log(formData);

        return (
            <div className="apartment-container">
                {/*<pre>{JSON.stringify(formData)}</pre>*/}
                    <ConfigProvider direction={this.props.lang === 'ar' ? 'rtl' : 'ltr'}>
                        <Card>
                            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px', alignItems: 'center', zIndex: 2, position: 'relative'}}>
                            <h3 style={{margin: 0}}>{language(this.props.lang, 'apartment_list')}</h3>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                float: this.props.lang === 'ar' ? 'left' : 'right',
                                marginBottom: '10px'
                            }}>
                                <Button type="primary" onClick={() => this.setModalVisible(true)} size={"large"}
                                        shape="circle" icon={<PlusOutlined/>}/>
                                <Modal
                                    title={this.state.mode === "edit"? language(this.props.lang, 'edit_apartment') :language(this.props.lang, 'add_apartment')}
                                    visible={this.state.addModalVisible}
                                    footer={null}
                                    onCancel={() => this.setModalVisible(false)}
                                >
                                    <Form
                                        variant={'filled'}
                                        name={"apartment-form"}
                                        style={{ maxWidth: 800, width: '800' }}
                                        initialValues={{
                                            buildingNo: formData.buildingNo || '',
                                            name: formData.name || '',
                                            buildingName: formData.buildingName || '',
                                            apartmentNo: formData.apartmentNo || '',
                                            streetName: formData.streetName || '',
                                            postalCode: formData.postalCode || '',
                                            city: formData.city || '',
                                            currencyType: formData.currencyType || '',
                                            amount: formData.amount || ''
                                        }}
                                        onFinish={(values) => this.handleAdd({...(this.state.formData || {}), ...values})}
                                    >

                                        <Form.Item label={language(this.props.lang, 'building_no')} name="buildingNo" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"buildingNo"} value={formData.buildingNo} onChange={this.handleChange}/>
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'site_name')} name="name" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"name"} value={formData.name} onChange={this.handleChange}/>
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'building_name')} name="buildingName" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"buildingName"} value={formData.buildingName} onChange={this.handleChange} />
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'apartment_no')} name="apartmentNo" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"apartmentNo"} value={formData.apartmentNo} onChange={this.handleChange} />
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'street_name')} name="streetName" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"streetName"} value={formData.streetName} onChange={this.handleChange} />
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'postal_code')} name="postalCode" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"postalCode"} value={formData.postalCode} onChange={this.handleChange} />
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'city')} name="city" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"city"} value={formData.city} onChange={this.handleChange} />
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'currency_type')} name="currencyType" rules={[{ required: true, message: 'Please input!' }]}>
                                            <Input name={"currencyType"} value={formData.currencyType} onChange={this.handleChange} />
                                        </Form.Item>
                                        <Form.Item label={language(this.props.lang, 'amount')} name="amount"  rules={[{ required: true, message: 'Please input!' }]}>
                                            <InputNumber name={"amount"} value={formData.amount} onChange={(e) => this.handleChange({target: {name: "amount", value: e}})} style={{ width: '100%' }} />
                                        </Form.Item>

                                    </Form>
                                    <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
                                        <Button type="primary" htmlType="submit" form="apartment-form">{language(this.props.lang, 'save')}</Button>
                                        <Button type="default" onClick={() => this.setModalVisible(false)}>{language(this.props.lang, 'cancel')}</Button>
                                    </div>
                                </Modal>

                            </div>
                            </div>

                            <Table dataSource={content}
                                   rowKey={record => record.recordId}
                                   size="small"
                                   columns={columns}
                                   onChange={this.onChange}
                                   loading={this.state.loading}
                                   locale={{
                                       filterConfirm: 'Tamam',
                                       filterReset: 'Temizle'
                                   }}
                                   pagination={{
                                       total,
                                       current,
                                       pageSize,
                                       pageSizeOptions,
                                       showSizeChanger: true,
                                       showQuickJumper: true,
                                       showTotal: (total) => language(this.props.lang, 'total_records') + ": " + total
                                   }}
                            />
                        </Card>
                    </ConfigProvider>
            </div>

        );
    }
}

export default ApartmentList;


// WEBPACK FOOTER //
// ./src/page/tenant/apartment/ApartmentList.js